/**
 * 通用 API 类型定义（v2）
 */

export interface ApiResponse<T = unknown> {
  code: string
  msg: string
  data: T
}

export interface PaginatedResponse<T = unknown> extends ApiResponse<T> {
  page?: number
  pageSize?: number
  total?: number
}

export interface PaginationParams {
  page?: number
  pageSize?: number
}

// ============ API 错误处理类型 ============

/**
 * API 错误响应体结构
 * @description 用于解析后端返回的错误信息
 */
export interface ApiErrorResponse {
  /** 错误详情（Django/FastAPI 风格） */
  detail?: string
  /** 通用错误消息 */
  message?: string
  /** 业务错误消息 */
  msg?: string
  /** 字段级别错误列表 */
  errors?: Array<{ message?: string, field?: string } | string>
}

/**
 * API 错误对象接口
 * @description 兼容 Axios Error 和自定义错误格式
 */
export interface ApiError {
  /** 错误消息 */
  message?: string
  /** 错误码（如 NETWORK_ERROR） */
  code?: string
  /** HTTP 响应信息 */
  response?: {
    status?: number
    data?: ApiErrorResponse | string
  }
}

/**
 * 类型守卫：判断是否为 ApiError
 * @param error 未知类型的错误对象
 * @returns 是否为 ApiError 类型
 */
export function isApiError(error: unknown): error is ApiError {
  if (typeof error !== 'object' || error === null) {
    return false
  }
  // 检查是否具有 ApiError 的典型属性
  return 'response' in error || 'message' in error || 'code' in error
}

/**
 * 类型守卫：判断是否为 Error 实例
 * @param error 未知类型的错误对象
 * @returns 是否为 Error 实例
 */
export function isError(error: unknown): error is Error {
  return error instanceof Error
}
